// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenu-cls1___25f8faa9ed69a5fb900","cls2":"AccountMenu-cls2__b6df1b2d73da4e715d89 AccountMenu-cls1___25f8faa9ed69a5fb900"};